import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import PermissionWrapper from '../../auth/PermissionWrapper';
class AdminPermissions extends Component {

  standardRow = (permission) => {
    this.props.info('AdminPermissions.js/standardRow (permission)', permission);
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(permission.id)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(permission['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((permission['active']) ? 'iconActive' : 'iconInactive')} />
          {permission['permission']}
        </Col>
        <Col md={3} className="text-left">{permission['description']}</Col>
        <Col md={3} className="text-left">{permission['api']}</Col>
        <Col md={2} className="text-left">{permission['method']}</Col>
        {/* <Col md={2} className="text-right>
          <Button className="mx-1" color="primary" onClick={() => this.props.onEdit(permission.ID)}><FontAwesomeIcon icon={faEdit} /></Button>
        </Col> */}
      </Row>
    )
  }

  editRow = (permission) => {
    this.props.log('AdminPermissions.js/editRow (permission)', permission);
    return (
      <Row className="editRow adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Permission"
                type={"edit-permission" + permission.id}
                id="permission-edit"
                name="permission"
                value={this.props.isFieldNull(this.props.editPermission.permission)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type={"edit-description" + permission.id}
                id="permission-description"
                name="description"
                value={this.props.isFieldNull(this.props.editPermission.description)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="APIs"
                type={"edit-api" + permission.id}
                id="permission-api"
                name="api"
                value={this.props.isFieldNull(this.props.editPermission.api)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Methods"
                type={"edit-method" + permission.id}
                id="permission-method"
                name="method"
                value={this.props.isFieldNull(this.props.editPermission.method)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"edit-active" + permission.id}
                name="active"
                checked={this.props.isFieldNull(this.props.editPermission.active, true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + permission.id}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Permission">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Permission">
            <ConfirmButton className="mx-1" color="danger" onClick={() => this.props.onDelete(this.props.editPermission.id)}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={6} className="text-right p-3">
          Assigned Roles
          <div className="mt-3">
            <Label for={"userRolePermissions_all"}>
              <Input
                type="checkbox"
                name="roles"
                id={"userRolePermissions_all"}
                checked={[...this.props.roles].filter(role => (role.permissions.findIndex(permission => permission === this.props.editPermission.id) > -1)).length === this.props.roles.length}
                onChange={e => this.props.onSelectAll(e, {
                  type: 'permissions',
                  typeKey: 'id',
                  target: 'roles',
                  filterType: 'editPermission',
                  filterKey: 'id',
                })}
              />
              Select All
            </Label>
          </div>
        </Col>
        <Col md={6} className="text-left py-3 pl-5 maxHpanel">
          {this.props.roles.map(role => (
            <div key={role.id}><Label for={"role_" + role.id}>
              <Input
                type="checkbox"
                name="roles"
                id={"role_" + role.id + "_" + permission.id}
                checked={this.props.isFieldNull([...this.props.roles].filter(o => o.permissions.findIndex(j => j === permission.id) > -1).map(i => i.id).findIndex(u => u === role.id) > -1, true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {role['role']}
            </Label></div>
          ))}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    this.props.info('AdminPermissions.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Permission
            </FormGroup> */}
            <FormGroup className="px-2">
              <Input
                placeholder="New Permission"
                type="text"
                id="permission-add"
                name="permission"
                value={this.props.isFieldNull(this.props.newPermission.permission)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type="text"
                id="permission-add-description"
                name="description"
                value={this.props.isFieldNull(this.props.newPermission.description)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="API"
                type="text"
                id="permission-add-api"
                name="api"
                value={this.props.isFieldNull(this.props.newPermission.api)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Method"
                type="text"
                id="permission-add-method"
                name="method"
                value={this.props.isFieldNull(this.props.newPermission.method)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"permission-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newPermission.active, true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"permission-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newPermission.permission === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Permission</Button>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.permissions.map(permission => (
          <Fragment key={permission.id}>{this.props.editPermission.id === permission.id ? this.editRow(permission) : this.standardRow(permission)}</Fragment>
        ))}
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Permissions">
          {this.addRow()}
        </PermissionWrapper>
      </Container>
    );

  }
}

export default AdminPermissions;